import React from 'react'
import Service from '../Service'

const CustomSoftware = () => {
    const title = 'Custom Software Development'
    const description = 'Bug Resistance designs and builds tailored software solutions that address your unique business challenges. From enterprise resource planning to workflow automation, we create custom applications that integrate seamlessly into your operations and scale with your growth.'
  return (
    <>
        <Service title={title} description={description} />
    </>
  )
}

export default CustomSoftware
